import { TransportService } from "../services/TransportService";
import { RootStore } from "./RootStore";
import {
  computed,
  makeObservable,
  observable,
  runInAction,
  when,
} from "mobx";
import { User } from "../models/User";
import DataStore from "./DataStore";
import { AxiosError } from "axios";

export class UserStore extends DataStore {
  rootStore: RootStore;
  _user: User | null = null;
  setUser = (user: User | null) => {
    runInAction(() => {
      this._user = user;
    });
  };

  get user() {
    if (!this._user) {
      this.getUser();
    }

    return this._user;
  }

  constructor(transportService: TransportService, rootStore: RootStore) {
    super(transportService);
    makeObservable(this, {
      _user: observable,
      error: observable,
      initialized: observable,
      loading: observable,
      user: computed,
      isIphoneUser: computed
    });
    this.rootStore = rootStore;
  }

  get isIphoneUser() {
    return navigator.platform.startsWith("iP") ||
    (navigator.platform.startsWith("Mac") && navigator.maxTouchPoints > 4);
  }

  protected getUser = async () => {
    this.setLoading("user");
    const token = await this.rootStore.keycloakStore.getRefreshedToken();
    if (!token) {
      return;
    }

    try {
      const res = await this.transportService.getWithToken(
        "/user/me",
        token
      );
      const user = res?.data as User;
      if(!user?.isRegistered) {
        this.setError("not_registererd");
      }
      return this.setUser(user);
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status == 403) {
        console.error(e);
        this.setError("user_403");
        return;
      }
      console.error(e);
      this.setError("user");
      return;
    } finally {
      this.clearLoading("user");
      this.setInitialized(true);
    }
  };

  async getUserData() {
    const token = await this.rootStore.keycloakStore.getRefreshedToken();

    await when(() => this.user !== null);

    return { user: this.user, token: token };
  }
}
